const CookiesActionTypes = {
  SET_IS_COOKIE_ACCEPTED: "SET_IS_COOKIE_ACCEPTED",
};
export default CookiesActionTypes;
